import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=5a04387a&scoped=true&"
import script from "./Video.vue?vue&type=script&lang=ts&"
export * from "./Video.vue?vue&type=script&lang=ts&"
import style0 from "./Video.vue?vue&type=style&index=0&id=5a04387a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a04387a",
  null
  
)

export default component.exports